var bForm;

bForm = function() {
  var $, module, moduleCheckLabels, moduleName;
  moduleName = 'b-form';
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  moduleCheckLabels = module.find("." + moduleName + "__var");
  return moduleCheckLabels.each(function() {
    var thisCheck, thisCheckLabel;
    thisCheckLabel = $(this);
    thisCheck = thisCheckLabel.parents("." + moduleName + "__check");
    if (thisCheck.data('yourchoise') === void 0) {
      return thisCheckLabel.click(function() {
        var $this, $thisCheckbox;
        $this = $(this);
        $thisCheckbox = thisCheck.find(".checkbox");
        if ($thisCheckbox.length < 1) {
          $thisCheckbox = thisCheck.find(".radiobox");
        }
        return $thisCheckbox.trigger('click');
      });
    } else {

    }
  });
};

module.exports = bForm;
